<template>
	<div class="unit-body">
		<div class="fx-header">
			<p>商品单位</p>
		</div>
		<div class="body-box">
			<div class="header-btn-box">
				<el-button size="mini" style="width:105px;height:32px;" v-if="AuthorityList['02_0003_0003_00']" plain type="primary" @click="addClick">新建</el-button>
				<div style="color:#666666"><i style="color:var(--fx-primary-color)" class="el-icon-info"></i> 可拖动行修改排序</div>
			</div>
			<div class="table-box">
				<el-table
					ref='table'
					class="grid-content"
					:data="tableData"
					border
					size='mini'
					height="100%">
					<el-table-column
						prop="name"
						align="center"
						label="单位">
					</el-table-column>
					<el-table-column label="操作" width="180" align="center">
						<template slot-scope="scope">
							<el-button v-if="AuthorityList['02_0003_0002_00']" size="mini" type='text' :disabled='scope.row.useFlag === 1' @click="editClick(scope.row)"><i class="el-icon-edit-outline"></i> 编辑</el-button>
							<el-button v-if="AuthorityList['02_0003_0004_00']" size="mini" type='text' :disabled='scope.row.useFlag === 1' @click="delClick(scope.row)"><i class="el-icon-delete"></i>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<el-dialog
			:title="isAdd ? '新建商品单位':'编辑商品单位'"
			:before-close="cancelEdit"
			class="unit-dialog"
			:visible.sync="showEdit"
			width='400px'
			height='300px'
			:close-on-click-modal="false">
			<div class="info-box">
				单位名称：
				<el-input size='mini' style="width:200px" v-model="name" placeholder="请输入单位名称 ≤4个字符"></el-input>
			</div>
			<el-button v-if="isAdd" type="primary" size="mini" plain  @click="save(false)">保存</el-button>
			<el-button v-if="isAdd" type="primary" size="mini" @click="save(true)">保存并新增</el-button>
			<el-button v-if="!isAdd" type="primary" size="mini" plain @click="cancelEdit">取消</el-button>
			<el-button v-if="!isAdd" type="primary" size="mini" @click="save(false)">保存</el-button>
		</el-dialog>
	</div>
</template>
<script>
import Sortable from 'sortablejs'
export default {
	name: 'units',
	data () {
		return {
			id: 0,
			name: '',
			showEdit: false,
			isAdd: false,
			tableData: [],
			AuthorityList: {
				'02_0003_0001_00': false,
				'02_0003_0002_00': false,
				'02_0003_0003_00': false,
				'02_0003_0004_00': false
			}
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '4-3')
		this.getAuthority('02_0003_0000_00')
		this.getTable()
	},
	mounted () {
		let _this = this
		const table = document.querySelector('.el-table__body-wrapper tbody')
		Sortable.create(table, {
			onEnd ({ newIndex, oldIndex }) {
				_this.sortData(_this.tableData[oldIndex].id, oldIndex, newIndex)
			}
		})
	},
	methods: {
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		save (flag) {
			if (this.name === '') {
				this.$message.error('请输入单位名称')
				return false
			}
			if (this.name.length > 4) {
				this.$message.error('最多输入4个字符')
				return false
			}
			let params = {
				id: this.id,
				name: this.name
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/saveOrUpdateProductUnit`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功')
					if (flag) {
						this.name = ''
						this.id = 0
					} else {
						this.showEdit = false
						this.getTable()
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		editClick (row) {
			this.isAdd = false
			this.id = row.id
			this.name = row.name
			this.showEdit = true
		},
		delClick (row) {
			let params = {
				name: row.name,
				id: row.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/delProductUnit`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功')
					this.getTable()
				}
			})
		},
		getTable () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/findProductUnit`
			}).then(res => {
				if (res.result) {
					this.tableData = res.data
				}
			})
		},
		sortData (id, seqnum, newSeqnum) {
			let params = {
				id: id,
				seqnum: seqnum,
				newSeqnum: newSeqnum
			}
			console.log(params)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/orderProductUnit`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData = []
					this.getTable()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		addClick () {
			this.isAdd = true
			this.name = ''
			this.id = 0
			this.showEdit = true
		},
		cancelEdit () {
			this.showEdit = false
			this.getTable()
		}
	}
}
</script>

<style lang="stylus" scoped>
.unit-body{
	display :flex;
	height :100%;
	flex-direction :column;
	.body-box{
		display :flex;
		flex-direction :column;
		height:100%;
		width :600px;
		padding-bottom :10px
	}
	.header-btn-box{
		height :80px;
		width :100%;
		display :flex;
		flex-direction :row;
		align-items :center;
		justify-content :space-between
	}
	.table-box{
		flex:1;
		min-height: 0;
		width:100%;
	}
	.info-box{
		display :flex;
		margin-bottom :20px;
		flex-direction :row;
		align-items :center
	}
}

</style>
<style lang="stylus">
.unit-dialog{
	.el-dialog__header{
		text-align :left
	}
	.el-dialog__body{
		padding:10px;
	}
}
</style>

